
"use strict"

// import componentName from './path/to/componentName'
import expand from './components/expand'
import asyncLoadOnScroll from './utility/asyncLoadOnScroll'
import videoLightbox from './components/video'
import logoCarousel from './components/logo-carousel'
import featureCarousel from './components/feature-carousel'
import accreditationCarousel from './components/accreditation-carousel'
import featuredinCarousel from './components/featuredin-carousel'
import areasCovered from './components/areas-covered'
import reviewSlider from './components/review-slider'
import './components/mobile-navigation'
import './components/which-areas'
import './components/navigation'
import './components/load-row'

videoLightbox()
logoCarousel()
featureCarousel()
accreditationCarousel()
featuredinCarousel()
areasCovered()
reviewSlider()

expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})

document.documentElement.classList.remove('no-js')
document.documentElement.classList.add('js')

const body = document.querySelector('body')
const callbackAction = [...document.querySelectorAll('a[href="#callback-modal"]')]
const callbackModal = document.querySelector('.callback-modal')
const callbackModalOverlay = document.querySelector('.callback-modal__overlay')
const callbackClose = document.querySelector('.callback-modal__close')

let isActive = false

function close() {
    isActive = false
    animateOut(callbackModal)
}

function open() {
    isActive = true
    animateIn(callbackModal)
}

function toggle() {
	isActive ? close() : open()
}

callbackAction.map(action => {
    action.addEventListener('click', toggle)
})
callbackModalOverlay.addEventListener('click', close)
callbackClose.addEventListener('click', close)


// detect esc key
window.addEventListener('keydown', event => {
	const escKey = (event.key === 'Escape' || event.keyCode === 27)
	const isActive = callbackModal.classList.contains('active')
	if (isActive && escKey) toggle()
})

// Animations
function animateIn(el) {
	el.style.display="flex"
	setTimeout(() => {
		el.classList.add('active') 
	}, 200);
}

function animateOut(el) {
	el.classList.remove('active')
	setTimeout(() => {
		el.style.display="none"
	}, 500); 
}
